import MainLayout from 'layouts/MainLayout';

import AssistantsListPage from 'pages/Assistants/List';
import AssistantsEditPage from 'pages/Assistants/Edit';
import AssistantsCreatePage from 'pages/Assistants/Create';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/assistants',
        element: AssistantsListPage,
        exact: true,
        analytics: { name: ["Assistenti"] },
    },{
        path: '/assistants/:assistantId/edit',
        element: AssistantsEditPage,
        exact: true,
        analytics: { name: ["Assistenti", "Modifica"] },
    },{
        path: '/assistants/create',
        element: AssistantsCreatePage,
        exact: true,
        analytics: { name: ["Assistenti", "Crea"] },
    }]
}]

export default routes;